import { render, staticRenderFns } from "./ShelfGrid1000.vue?vue&type=template&id=7837be04&scoped=true&"
import script from "./ShelfGrid1000.vue?vue&type=script&lang=js&"
export * from "./ShelfGrid1000.vue?vue&type=script&lang=js&"
import style0 from "./ShelfGrid1000.vue?vue&type=style&index=0&id=7837be04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7837be04",
  null
  
)

export default component.exports